/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The OfferScore model module.
 * @module model/OfferScore
 * @version 1.0.0
 */
class OfferScore {
    /**
     * Constructs a new <code>OfferScore</code>.
     * @alias module:model/OfferScore
     */
    constructor() { 
        
        OfferScore.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>OfferScore</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/OfferScore} obj Optional instance to populate.
     * @return {module:model/OfferScore} The populated <code>OfferScore</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OfferScore();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('read_probability')) {
                obj['read_probability'] = ApiClient.convertToType(data['read_probability'], 'Number');
            }
            if (data.hasOwnProperty('match_probability')) {
                obj['match_probability'] = ApiClient.convertToType(data['match_probability'], 'Number');
            }
            if (data.hasOwnProperty('score')) {
                obj['score'] = ApiClient.convertToType(data['score'], 'Number');
            }
            if (data.hasOwnProperty('model_version')) {
                obj['model_version'] = ApiClient.convertToType(data['model_version'], 'String');
            }
            if (data.hasOwnProperty('scored_at')) {
                obj['scored_at'] = ApiClient.convertToType(data['scored_at'], 'Date');
            }
            if (data.hasOwnProperty('features')) {
                obj['features'] = ApiClient.convertToType(data['features'], Object);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>OfferScore</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>OfferScore</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['model_version'] && !(typeof data['model_version'] === 'string' || data['model_version'] instanceof String)) {
            throw new Error("Expected the field `model_version` to be a primitive type in the JSON string but got " + data['model_version']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
OfferScore.prototype['id'] = undefined;

/**
 * ユーザーが提案を閲覧する推定確率
 * @member {Number} read_probability
 */
OfferScore.prototype['read_probability'] = undefined;

/**
 * ユーザーが提案を承認・マッチする推定確率
 * @member {Number} match_probability
 */
OfferScore.prototype['match_probability'] = undefined;

/**
 * 表示や並び替えに利用する総合スコア
 * @member {Number} score
 */
OfferScore.prototype['score'] = undefined;

/**
 * スコア算出に利用したモデルバージョン
 * @member {String} model_version
 */
OfferScore.prototype['model_version'] = undefined;

/**
 * スコア算出日時
 * @member {Date} scored_at
 */
OfferScore.prototype['scored_at'] = undefined;

/**
 * スコア算出時に利用した特徴量
 * @member {Object} features
 */
OfferScore.prototype['features'] = undefined;






export default OfferScore;

